import { Component, OnDestroy} from '@angular/core';
import { Subject } from 'rxjs';

/**
 * `CrsUnsubscriberComponent` is an anstract class with only ngdestroy implmentation.
 * Classes using rxjs observables and  subscribing to any of stream will have to use
 * the takeUntil operator with argument as `unsubscribe$` member variable of this class
 * and should extend this component. This is an to avoid code duplication in components and 
 * removing the dependency from developers for below
 *     1. Forgetting to implement the OnDestroy interface itself
 *     2. Forgetting to call .next() and .complete() methods in the ngOnDestroy implementation (leaving it empty).
 *
 */
@Component({
  template: '<div></div>'
})
export class CrsUnsubscriberComponent implements OnDestroy {

  //creating subject which will be used by components. this wil be used as argument to takeUntil
  protected unsubscribe$: Subject<boolean> = new Subject<boolean>();

  ngOnDestroy(): void {
    console.log(`killing subscriber for ${this.constructor.name}`);
    this.unsubscribe$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.unsubscribe$.complete();
  }
}